import { useSelector } from 'react-redux';
import { Button } from '@cropler/ui-kit';
import dayjs from 'dayjs';


import { DateLLFormat } from '../../constants/data';

import styles from './styles.module.scss';
import { NoteButton } from './index.jsx';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const Note = ({ t, note, color, isDarkTheme, isCompactView, onRemoveNote, onEditNote }) => {
  const { currentUserId } = useSelector((state) => state.auth);

  return (
    <div
      className={`${styles.note} ${isDarkTheme ? styles.noteDark : ''} ${isCompactView ? styles.noteCompact : ''}`}
      key={note.id}
    >
      <div className={styles.noteHeader}>
        <NoteButton type={note.note_type} color={color} isButton={false} t={t} />
        <div className={styles.noteDate}>{dayjs(note.created_at).format(DateLLFormat)}</div>
        <div className={styles.noteAuthor}>
          {(note.author.first_name || note.author.last_name) && (
            <span>
              {note.author.first_name} {note.author.last_name}
            </span>
          )}
          {note.author && note.author.avatar && (
            <div className={styles.noteAuthorAvatar}>
              <img src={note.author.avatar || ''} alt={note.author.first_name || ''} />
            </div>
          )}
        </div>
      </div>
      <div className={styles.noteText}>{note.content}</div>
      {currentUserId === note.author.id && (
        <div className={styles.noteNav}>
          <Button
            className={styles.noteNavEdit}
            type="text"
            size="small"
            icon={<CroplerIcon name="edit" />}
            onClick={() => onEditNote()}
          >
            {t('actions.edit')}
          </Button>
          <Button
            className={styles.noteNavRemove}
            type="text"
            size="small"
            icon={<CroplerIcon name="remove" />}
            onClick={() => onRemoveNote()}
          />
        </div>
      )}
    </div>
  );
};

export default Note;
